// extracted by mini-css-extract-plugin
module.exports = {"text":"_AnxH3b3y","error":"_AMMfG-4F"};